import React from 'react';
import { Link } from 'react-router-dom';
import { useCategories, customCategories, isCategoryOn } from '../utils/categories';
import './Footer.css';

// Built-in collections in the footer; a category turned off in admin drops out.
const FOOTER_COLLECTIONS = [
  ['veg-pickles', 'Veg Pickles'], ['non-veg-pickles', 'Non-Veg Pickles'], ['powders', 'Podis & Powders'],
  ['snacks', 'Snacks'], ['sweets', 'Sweets'], ['ghee', 'Ghee'], ['gift-hampers', 'Gift Hampers'],
];

const Footer = () => {
  const cats = useCategories();
  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="container footer-grid">
          {/* Brand */}
          <div className="footer-brand">
            <Link to="/" className="footer-logo">
              <img src="/avakaaya-logo.png" alt="Avakaaya Foods" className="footer-logo-img" />
            </Link>
            <div className="footer-company">Avakaaya Foods Pvt Ltd</div>
            <address className="footer-address">
              15-27-737, 1st Phase, Dharma Reddy Colony Phase I,<br />
              Kukatpally, Hyderabad, Telangana 500072
            </address>
            <p className="footer-tagline">
              Authentic Telugu flavours, crafted with love in Hyderabad since generations.
            </p>
            <div className="footer-social">
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                <svg width="20" height="20" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                </svg>
              </a>
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                <svg width="20" height="20" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                </svg>
              </a>
              <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
                <svg width="20" height="20" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
                </svg>
              </a>
              <a href="https://wa.me/919115595959" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp">
                <svg width="20" height="20" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413Z"/>
                </svg>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-col">
            <h4 className="footer-heading">Quick Links</h4>
            <ul className="footer-links">
              <li><Link to="/products">All Products</Link></li>
              {FOOTER_COLLECTIONS.filter(([slug]) => isCategoryOn(cats, slug)).map(([slug, label]) => (
                <li key={slug}><Link to={`/collections/${slug}`}>{label}</Link></li>
              ))}
              {customCategories(cats).map((c) => <li key={c.value}><Link to={`/collections/${c.value}`}>{c.label}</Link></li>)}
              <li><Link to="/about">Our Story</Link></li>
            </ul>
          </div>

          {/* Customer Care */}
          <div className="footer-col">
            <h4 className="footer-heading">Customer Care</h4>
            <ul className="footer-links">
              <li><Link to="/contact">Contact Us</Link></li>
              <li><Link to="/store-locations">Visit Our Stores</Link></li>
              <li><Link to="/shipping-info">Shipping Information</Link></li>
              <li><Link to="/refund-policy">Refund &amp; Cancellation</Link></li>
              <li><Link to="/privacy-policy">Privacy Policy</Link></li>
              <li><Link to="/terms">Terms &amp; Conditions</Link></li>
              <li><a href="mailto:care@avakaayafoods.com">care@avakaayafoods.com</a></li>
              <li><a href="tel:+919115595959">+91 91155 95959</a></li>
              <li><a href="https://wa.me/919115595959">WhatsApp Support</a></li>
            </ul>
          </div>

          {/* Shipping Countries */}
          <div className="footer-col">
            <h4 className="footer-heading">We Ship To</h4>
            <div className="footer-countries">
              {[
                { flag: '🇮🇳', name: 'India', note: '1–2 days' },
                { flag: '🇺🇸', name: 'USA', note: '3–7 days' },
                { flag: '🇬🇧', name: 'United Kingdom', note: '3–7 days' },
                { flag: '🇸🇬', name: 'Singapore', note: '3–7 days' },
                { flag: '🇦🇺', name: 'Australia', note: '3–7 days' },
                { flag: '🇲🇾', name: 'Malaysia', note: '3–7 days' },
              ].map(c => (
                <div key={c.name} className="footer-country-item">
                  <span className="country-flag">{c.flag}</span>
                  <span className="country-name">{c.name}</span>
                  <span className="country-note">{c.note}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container footer-bottom-inner">
          <p className="footer-copy">
            © {new Date().getFullYear()} Avakaaya Foods. All rights reserved. Made with ❤️ in Hyderabad.
          </p>
          <div className="footer-payment-icons">
            <span className="payment-badge">Visa</span>
            <span className="payment-badge">Mastercard</span>
            <span className="payment-badge">UPI</span>
            <span className="payment-badge">Net Banking</span>
            <span className="payment-badge">ICICI Bank</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
